import React from 'react';
import FontIcon from '../FontIcons/FontIcon';

export default function getDeprecatedIcon(className, children, icon) {
  if (className || children) {
    return React.createElement(
      FontIcon,
      { iconClassName: className },
      children
    );
  }

  return icon;
}


//////////////////
// WEBPACK FOOTER
// ../es/FontIcons/getDeprecatedIcon.js
// module id = 4551
// module chunks = 73